export const ProductScheduleType = {
    Software: "Software",
    System: "System",
    Accessory: "Accessory",
  };
  